module.exports = __webpack_public_path__ + "static/media/shanghai-9-highlight.6a226ade.png";